import { ConfigProvider } from 'antd';
import { combineConfigProvider } from 'hrst-components';

const CustomProvider = combineConfigProvider(ConfigProvider);

export default CustomProvider;
